module.exports = __webpack_public_path__ + "static/media/p8.a1eafabb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p8.png
// module id = 962
// module chunks = 0